import { ButtonType, DialogFooterButtonsWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

import { CommonStyles } from '~common/react/CommonStyles';
import { Formatters, Messages } from '~src/codegen/Localize';
import { ExtractTasks } from '~src/extract/resources/ExtractTasks';
import { PublishedConnections } from '~src/publishedConnection/resources/PublishedConnections';
import { cssClass } from '~src/style';
import { L10n } from '~src/ts/L10n/L10n';
import { IPublishedConnectionTaskInfo } from '~src/ts/models/IPublishedConnectionTaskInfo';

import { PublishedConnectionTaskSchedulePicker } from './PublishedConnectionTaskSchedulePicker';

const cssPrefix = 'PublishedConnectionEditScheduleDialogContent';

const rootClass = cssClass(cssPrefix, 'root', {
  padding: `0 ${CommonStyles.Sizes.SmallSpace}px ${CommonStyles.Sizes.LargeSpace}px`
});

const dialogMessageClass = cssClass(cssPrefix, 'dialogMessage', {
  marginBottom: TabStyles.Spacing.LargeSpace,
  wordWrap: 'break-word'
});

export const PublishedConnectionEditScheduleDialogContent: React.FC<{
  close: () => void;
  dismiss: () => void;
  tasks: ReadonlyArray<IPublishedConnectionTaskInfo>;
}> = (
  {
    close,
    dismiss,
    tasks
  }) => {
  const [selectedSchedule, setSelectedSchedule] = React.useState('');
  const handleSelectSchedule = React.useCallback((value) => setSelectedSchedule(value), []);

  const handleEditSchedule = React.useCallback(
    () => {
      ExtractTasks.setSchedule(tasks.map(task => task.id), selectedSchedule).then(
        result => {
          PublishedConnections.toast(result,
            Messages.changeSchedulePublishedConnectionTasksSuccess({
              ITEM_COUNT: tasks.length,
              ITEM_COUNT_LOC: Formatters.formatCount(tasks.length)
            }),
            Messages.changeSchedulePublishedConnectionTasksError({
              ERROR_COUNT: result.errors.length,
              ERROR_COUNT_LOC: Formatters.formatCount(result.errors.length)
            })
          );
          close();
        }
      );
    },
    [close, selectedSchedule, tasks]
  );

  return (
    <div>
      <div className={rootClass}>
        <div
          className={dialogMessageClass}>{Messages.changeScheduleExtractTasksPrompt({ COUNT_LOC: L10n.localizedCount(tasks.length) })}</div>
        <PublishedConnectionTaskSchedulePicker
          scheduleId={selectedSchedule}
          onSelect={handleSelectSchedule}
        />
      </div>

      <DialogFooterButtonsWidget
        buttons={[{
          handleClick: dismiss,
          buttonType: ButtonType.Outline,
          children: Messages.cancel(),
          testId: 'edit-published-connection-schedule-cancel'
        }, {
          handleClick: handleEditSchedule,
          buttonType: ButtonType.Primary,
          children: Messages.changeSubscriptionsFrequencyConfirm({
            COUNT: tasks.length,
            COUNT_LOC: L10n.localizedCount(tasks.length)
          }),
          testId: 'edit-published-connection-schedule-go',
          disabled: !selectedSchedule
        }]}
        testId={'edit-published-connection-schedule-footer'}
      />
    </div>
  );
};
PublishedConnectionEditScheduleDialogContent.displayName = 'PublishedConnectionEditScheduleDialogContent';
